import * as deviceDetect from 'react-device-detect';

const UNKNOWN = 'unknown';
const NONE = 'none';
const FALLBACK_APPLICATION_METADATA = {
  device: {
    type: UNKNOWN,
    mobileModel: NONE,
    browserName: UNKNOWN,
    browserVersion: UNKNOWN,
    osName: UNKNOWN,
    osVersion: UNKNOWN,
  },
};

const normaliseMetadataValue = (value, fallback = UNKNOWN) => {
  if (typeof value === 'string') {
    const trimmedValue = value.trim();
    return trimmedValue || fallback;
  }

  if (typeof value === 'number' || typeof value === 'boolean') {
    return `${value}`;
  }

  return fallback;
};

const getDeviceType = deviceInfo => {
  if (deviceInfo.isTablet) {
    return 'tablet';
  }

  if (deviceInfo.isMobile) {
    return 'mobile';
  }

  if (deviceInfo.isDesktop) {
    return 'desktop';
  }

  return UNKNOWN;
};

export const createApplicationMetadata = (deviceInfo = deviceDetect) => ({
  device: {
    type: getDeviceType(deviceInfo),
    mobileModel: normaliseMetadataValue(deviceInfo.mobileModel, NONE),
    browserName: normaliseMetadataValue(deviceInfo.browserName),
    browserVersion: normaliseMetadataValue(deviceInfo.browserVersion),
    osName: normaliseMetadataValue(deviceInfo.osName),
    osVersion: normaliseMetadataValue(deviceInfo.osVersion),
  },
});

export const getApplicationMetadata = () => createApplicationMetadata();

export const getApplicationMetadataJson = () => {
  try {
    return JSON.stringify(getApplicationMetadata());
  } catch (error) {
    return JSON.stringify(FALLBACK_APPLICATION_METADATA);
  }
};
